/* eslint-disable @repo/internal/react/require-jsdoc */
import React, { type ReactNode, useState } from 'react';

import Button from '@atlaskit/button/new';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { ProgressIndicator } from '@atlaskit/progress-indicator';

import { RelativePosition } from '../position';

import { Description } from './components/description';

const rootStyles = xcss({
	borderRadius: '12px',
	overflow: 'hidden',
});

const progressIndicatorContainerStyles = xcss({
	backgroundColor: 'color.background.neutral',
	padding: 'space.200',
});

export const Carousel = ({
	name,
	panels,
	step = 0,
}: {
	name?: string;
	step?: number;
	panels: {
		description: string;
		content: ReactNode;
	}[];
}) => {
	const [selectedIndex, setSelectedIndex] = useState(step);

	const handlePrev = () =>
		setSelectedIndex((prevState) => (prevState - 1 + panels.length) % panels.length);
	const handleNext = () =>
		setSelectedIndex((prevState) => (prevState + 1 + panels.length) % panels.length);
	const { description, content } = panels[selectedIndex];
	return (
		<Box xcss={rootStyles}>
			<ProgressIndicatorPanel id={`${name}-panel${selectedIndex}`}>
				<RelativePosition>
					{content}
					<FloatOnDesktop>
						<Description>{description}</Description>
					</FloatOnDesktop>
				</RelativePosition>
			</ProgressIndicatorPanel>
			<Inline
				xcss={progressIndicatorContainerStyles}
				space="space.100"
				spread="space-between"
				alignBlock="center"
			>
				<Button onClick={handlePrev}>Prev</Button>
				<ProgressIndicator
					ariaControls={`${name ? `${name}-` : ''}panel`}
					ariaLabel={`${name ? `${name}-` : ''}tab`}
					selectedIndex={selectedIndex}
					values={panels}
				/>
				<Button onClick={handleNext}>Next</Button>
			</Inline>
		</Box>
	);
};

const ProgressIndicatorPanel = ({ children, id }: { children: ReactNode; id: string }) => {
	return (
		<Box id={id} role="tabpanel">
			{children}
		</Box>
	);
};

const floatOnDesktopStyles = xcss({
	position: 'static',
	'@media (min-width: 48rem)': {
		position: 'absolute',
		insetBlockEnd: 'space.200',
		insetInlineStart: 'space.200',
	},
});

const FloatOnDesktop = ({ children }: { children: ReactNode }) => {
	return <Box xcss={floatOnDesktopStyles}>{children}</Box>;
};
